var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFrowningCalendar = function SvgFrowningCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 120,
    fill: "none",
    viewBox: "0 0 105 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 9,
    d: "M44 91s2.24-4.663 7.515-8.497 11.41-2.845 11.41-2.845"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#767676",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M32.5 61.5s9 2 13.5-5.5M60.027 55.934s4.964 7.769 13.446 5.632"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    stroke: "#767676",
    strokeWidth: 0.5,
    d: "M40.857 69.008c2.715 0 5.107-2.242 5.107-5.129 0-2.729-2.387-5.129-5.107-5.129-2.876 0-5.107 2.405-5.107 5.13 0 2.88 2.236 5.128 5.107 5.128ZM65.143 58.75c-2.876 0-5.107 2.405-5.107 5.13 0 2.88 2.236 5.128 5.107 5.128 2.714 0 5.107-2.242 5.107-5.129 0-2.729-2.388-5.129-5.107-5.129Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    d: "M93.75 15H82.5V2.813C82.5 1.406 81.094 0 79.688 0h-1.876C76.173 0 75 1.406 75 2.813V15H30V2.813C30 1.406 28.594 0 27.188 0h-1.875C23.672 0 22.5 1.406 22.5 2.813V15H11.25C4.922 15 0 20.156 0 26.25v82.5C0 115.078 4.922 120 11.25 120h82.5c6.094 0 11.25-4.922 11.25-11.25v-82.5C105 20.156 99.844 15 93.75 15m-82.5 7.5h82.5c1.875 0 3.75 1.875 3.75 3.75V37.5h-90V26.25c0-1.875 1.64-3.75 3.75-3.75m82.5 90h-82.5c-2.11 0-3.75-1.641-3.75-3.75V45h90v63.75c0 2.109-1.875 3.75-3.75 3.75"
  })));
};
export default SvgFrowningCalendar;